import ReactPlayer from 'react-player/vimeo'
import {FaPlay} from 'react-icons/fa'
import api from '../../../_metronic/helpers/api'
import {useLocation, useNavigate} from 'react-router-dom'
import {showAlert} from '../../redux/reducers/alertSlice'
import {useDispatch} from 'react-redux'
import { useEffect, useState } from 'react'
import clsx from 'clsx'
import back from '../../../_metronic/assets/custom-icons/back.png';
import useUtils from './useUtils'
const PreviewModule = ({className}) => {
  const {state} = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [tab, setTab] = useState(1);
  const [values] = useState(state?.values)
  const imageURL = values?.image ? URL.createObjectURL(values?.image) : values?.imgUrl? values?.imgUrl : ''
  const {handleEdit} = useUtils()

  const publishModule = async () => {
    try {
      const response = await api.patch(`module/${values.id}`, {status: 'published'})
      console.log(response)
      if (response.data.status) {
        dispatch(showAlert({message: 'Module Published', variant: 'success'}))
        navigate('/modulelist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const onEdit = async(id) =>{
    const result = await handleEdit(id)
    navigate('/modulelist/editmodule', { state: {result}});
   }

   const onClone = async (id2) => { 
    const result = await handleEdit(id2)

    const { id, code, title, description, ...newResult } = result;
    navigate('/modulelist/addmodule', { state: {result:newResult}});
  }

  const submitModule = (id) => {
    publishModule(id)
  }

  const Details = () =>{
    return( 
        <div className='fs-6'>
        <div >{values?.description}</div>
      </div>
    )
  }

  const Units = () =>{
    return(
        <div className='fs-6'>
        <div > <ul style={{listStyleType: 'square'}}>
          {values?.units.map((val, index)=><li key={index} className="mb-1"><div>{val}</div></li>)}
            </ul></div>
      </div>
    )
  }

  return (
    <>
     <div className={`card ${className}`}>
     <img
            onClick={() => navigate(-1)}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            src={back}
            className="me-2"
          />
      <div className='pt-4 px-4 mb-3' style={{fontSize: '14px'}}>
        <div className='d-flex justify-content-between'>
          <div className='d-flex align-items-start flex-wrap gap-3'>
            {values?.image? (
              <img
                style={{cursor: 'pointer', width: '400px', height: '200px',objectFit:'cover'}}
                src={imageURL}
                alt=''
              ></img>
            ):values.imgUrl? (
              <img
              style={{cursor: 'pointer', width: '400px', height: '200px', objectFit:'cover'}}
              src={values.imgUrl}
              alt=''
            ></img>
            ):(
              <img  src='https://placehold.co/400x200?text= No Image' />
            )}
            <div className='d-flex flex-column t-14 gap-2 mt-2'>
            <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Code:</div>
                  <div>{values?.code}</div>
                </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Title:</div>
                <div>{values?.title}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Author Name:</div>
                <div>{values?.authorName}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Language:</div>
                <div>{values?.language}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Cohort:</div>
                <div>{values?.cohort}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Tags:</div>
                <div>
                  {values?.tags?.map((val, index) =>
                    values?.tags?.length - 1 === index ? val : val + ', '
                  )}
                </div>
              </div>
            </div>
          </div>
           
          <div>
          <button type='button' className='btn btn-primary text-nowrap ms-2 mt-2 me-2' onClick={()=>onClone(values?.id)}>
              Clone
            </button>
            <button type='button' className='btn btn-primary ms-2 mt-2 me-2' onClick={()=>onEdit(values?.id)}>
              Edit Module
            </button>

            {values.status!=='published'&&<button type='button' className='btn btn-primary ms-2 mt-2 me-2' onClick={submitModule}>
              Publish Module
            </button>}
          </div>
        </div>
 
        <div className='card-header card-header-stretch overflow-auto'>
          <ul
            className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
            role='tablist'
          >
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 1})}
                onClick={() => setTab(1)}
                role='tab'
              >
               Descriptions
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {active: tab === 2})}
                onClick={() => setTab(2)}
                role='tab'
              >
                Unit
              </a>
            </li>
          </ul>
        </div>

        <div className='card-body'>
                <div className='tab-content'>
                  <div className={clsx('tab-pane', {active: tab === 1})}>
                   <Details/>
                  </div>

                  <div className={clsx('tab-pane', {active: tab === 2})}>
                    <Units/>
                  </div>
             
                </div>
              </div>


      </div>
      </div>
    </>
  )
}

export {PreviewModule}
